import QuestionType from "@/models/Questions/QuestionType";

export default (questionType: QuestionType) => {
    let returnVal = "Unknown"
    switch (questionType) {
        case QuestionType.Currency:
            returnVal = "Currency";
            break;
        case QuestionType.Date:
            returnVal = "Date";
            break;
        case QuestionType.Decimal:
            returnVal = "Decimal";
            break;
        case QuestionType.DropDown:
            returnVal = "Drop Down";
            break;
        case QuestionType.FileUpload:
            returnVal = "File Upload";
            break;
        case QuestionType.Integer:
            returnVal = "Integer";
            break;
        case QuestionType.Legal:
            returnVal = "Legal";
            break;
        case QuestionType.MultipleChoice:
            returnVal = "Multiple Choice";
            break;
        case QuestionType.Text:
            returnVal = "Text";
            break;
        case QuestionType.TextArea:
            returnVal = "Text Area";
            break;
        case QuestionType.YesNo:
            returnVal = "Yes/No";
            break;
    }
    return returnVal;
} 